"use client";

import { useEffect } from "react";

import { trackPixel } from "/utils/metaPixel";

/**
 * Fires a Meta Pixel event once on mount. Used by App Router server components
 * (which can't run effects themselves) to track page views of key content.
 */
export default function TrackEvent({
  event,
  params
}: {
  event: string;
  params?: Record<string, unknown>;
}) {
  useEffect(() => {
    trackPixel(event, params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
